







import { Config } from '@/config'
import VueSimpleSpinner from 'vue-simple-spinner'
import Vue from 'vue'
import Component from 'vue-class-component'
import { VueRouter } from 'vue-router/types/router'
import { Injector } from '@/config/dependency-injection'
import { AuthenticationService } from '@/authentication/authentication-service'
import { RouterToken } from '@/config/injection-tokens'
import { NotificationService } from '@/shared/services/notification-service'
import { TranslateService } from '@/shared/services/translate-service'

@Component({
  components: { VueSimpleSpinner },
})
export default class Logout extends Vue {
  private authenticationService = Injector.get(AuthenticationService)
  private notificationService = Injector.get(NotificationService)
  private router = Injector.get<VueRouter>(RouterToken)
  private translationService = Injector.get(TranslateService)

  public created() {
    this.authenticationService.logout().then(() => {
      this.notificationService.success('logout.success', 'far fa-check')
      this.router.push(Config.defaultRoute)
    })
  }
}
